import React from 'react'
import { Header } from '../components/Header'
import { Footer } from '../components/Footer'
import { SubServiceCard } from '../components/SubServiceCard'
import { CTASection } from '../components/CTASection'
import { consultingServices } from '../data/mockData'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { ArrowLeftIcon, CheckCircle2Icon, ShieldCheckIcon, LockIcon, ServerIcon, GitBranchIcon, EyeIcon, UsersIcon, CpuIcon, LightbulbIcon, NetworkIcon, SearchIcon, BarChart3Icon, RefreshCwIcon, GanttChartSquareIcon, LayersIcon, BoxIcon, LayoutIcon, MessageSquareIcon } from 'lucide-react'
import { SeoHelmet } from '../components/SeoHelmet'
import { ROUTE_META } from '../data/routeMeta'

export function Consulting() {
  return (
    <div className="min-h-screen w-full bg-white flex flex-col font-['Roboto']">
      <SeoHelmet {...ROUTE_META['/consulting']} url="/consulting" pageType="website" />
      <Header />

      <main className="flex-1">
        <section className="relative w-full bg-navy py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80"
              alt="Server room security"
              className="w-full h-full object-cover opacity-20"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/90 to-transparent" />
          </div>

          <div className="max-w-5xl mx-auto relative z-10">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 text-white font-['Poppins']">
                Consulting, AI with{' '}
                <span className="text-primary">data privacy</span> and open
                source
              </h1>
              <p className="text-xl sm:text-2xl text-gray-300 leading-relaxed max-w-3xl">
                We help you adopt AI without giving away your data, locking into
                a vendor, or breaking compliance.
              </p>
            </motion.div>
          </div>
        </section>

        <section className="w-full py-24 px-4 sm:px-6 lg:px-8 bg-gray-50">
          <div className="max-w-5xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="mb-12 text-center"
            >
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 font-['Poppins']">
                How we can help
              </h2>
            </motion.div>

            <div className="space-y-8">
              {consultingServices.map((service, index) => (
                <SubServiceCard
                  key={index}
                  title={service.title}
                  description={service.description}
                  icon={service.icon}
                  delay={service.delay}
                />
              ))}
            </div>
          </div>
        </section>

        <CTASection />
      </main>

      <Footer />
    </div>
  )
}